import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

import { WORK_SHIFT_PATHS } from '../../work-shift/work-shift';
import { WORK_SHIFTS_PATHS } from '../../work-shifts/work-shifts';
import { SectorsService } from '../sectors.service';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { SectorRole } from '../sectors';
import { sectorRoleOptions } from '../constants/sector-role-options';

export interface MonitoringSectorsFilterParams {
  branches_ids: any[];
  mb_regions: any[];
  sectors_ids: any[];
  districts_ids: any[];
  offset: number;
  limit: number;
  sector_role: SectorRole;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss'],
  standalone: false,
})
export class MonitoringComponent implements OnInit {
  public WORK_SHIFT_PATHS = WORK_SHIFT_PATHS;
  public WORK_SHIFTS_PATHS = WORK_SHIFTS_PATHS;
  public plotsBreadcrumbs = [{ text: 'Мониторинг работы участков', url: null }];
  public filter = {
    data: {
      regions: null,
      branches: null,
      districts: null,
      sectorNumbers: null,
    },
    sectorRoleSelected: null,
    regionsSelected: null,
    branchesSelected: null,
    districtsSelected: null,
    sectorNumbersSelected: null,
    onChangeSectorRole: this.onChangeSectorRole.bind(this),
    onChangeRegions: this.onChangeRegions.bind(this),
    onChangeBranches: this.onChangeBranches.bind(this),
    onChangeDistricts: this.onChangeDistricts.bind(this),
    onChangeSectorsNumbers: this.onChangeSectorsNumbers.bind(this),
    onApplyFilter: this.onApplyFilter.bind(this),
    onResetFilter: this.onResetFilter.bind(this),
  };
  public paginationBlock = {
    limits: [25, 50, 100],
    selectedLimit: 25,
    countShowPlots: 25,
    filterDataMaxRows: null,
    filterDataOffset: 0,
  };
  public sectors = null;
  public monitoringDataUnionLoading: boolean;
  public sectorsDataLoading: boolean;
  public sectorOpenedActions = null;

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private sectorsService: SectorsService
  ) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.plotsBreadcrumbs);
    this.getMonitoringDataUnion();
  }

  private getMonitoringDataUnion(): void {
    let filter = this.filter;
    this.monitoringDataUnionLoading = true;
    this.sectorsService.getMonitoringDataUnion(this.makeSectorsParams()).subscribe(
      (response) => {
        filter.data.regions = response[0]['data'].map((region) => {
          return { name: region };
        });
        filter.data.branches = response[1]['data'];
        let sectors = response[2]['data'];
        filter.data.sectorNumbers = this.sectorsService.makeSectorsNumbers(response[3]['data']);

        this.sectors = sectors.results;
        this.paginationBlock.filterDataMaxRows = sectors.count;
        this.paginationBlock.filterDataOffset += sectors.results.length;
        this.monitoringDataUnionLoading = false;
      },
      (error) => {
        filter.data.regions = null;
        filter.data.branches = null;

        this.sectors = null;
        this.monitoringDataUnionLoading = false;
      }
    );
  }

  formatSectorRole(sectorRole: SectorRole) {
    const found =  sectorRoleOptions.find((item) => item.value === sectorRole)
    return found && found.name || '';
  }

  private getBranches(regions: any[]): void {
    this.filter.data.branches = null;
    this.sectorsService.getMonitoringBranches({ mb_regions: regions, available_only: 1 }).subscribe(
      (response) => {
        this.filter.data.branches = response['data'];
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public onChangeSectorRole(sectorRole: SectorRole): void {
    this.filter.sectorRoleSelected = sectorRole;
  }

  getSectorsNames(): void {
    const filter = this.filter;
    const params: any = {};

    if (filter.regionsSelected) {
      params.mb_regions = filter.regionsSelected;
    }

    if (filter.branchesSelected) {
      params.mb_ids = filter.branchesSelected;
    }

    this.sectorsService.getFilterPlots(params).subscribe(
      (response) => {
        this.filter.data.sectorNumbers = this.sectorsService.makeSectorsNumbers(response['data']);
      },
      (error) => {
        this.filter.data.branches = null;
      }
    );
  }

  getDistricts(): void {
    const filter = this.filter;
    const params: any = {
      available_only: 1,
    };

    if (filter.branchesSelected) {
      params.mb_ids = filter.branchesSelected;
    }

    if (filter.sectorNumbersSelected) {
      params.sectors_ids = filter.sectorNumbersSelected;
    }

    this.sectorsService.getMonitoringDistricts(params).subscribe(
      (response) => {
        this.filter.data.districts = response['data'].map((district) => {
          district.new_name = district.city.ct_name + ' - ' + district.district_name;

          return district;
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  makeSectorsParams(): MonitoringSectorsFilterParams {
    let filter = this.filter;
    return {
      branches_ids: filter.branchesSelected || '',
      mb_regions: filter.regionsSelected || '',
      sectors_ids: filter.sectorNumbersSelected || '',
      districts_ids: filter.districtsSelected || '',
      offset: this.paginationBlock.filterDataOffset,
      limit: this.paginationBlock.selectedLimit,
      sector_role: filter.sectorRoleSelected || '',
    };
  }

  getSectors(): void {
    this.sectorsDataLoading = true;
    this.sectorsService.getMonitoringSectors(this.makeSectorsParams()).subscribe(
      (response) => {
        let sectors = response['data'];

        if (!this.sectors) {
          this.sectors = [];
        }

        this.sectors = this.sectors.concat(sectors.results);
        this.paginationBlock.filterDataMaxRows = sectors.count;
        this.paginationBlock.filterDataOffset += sectors.results.length;
        this.sectorsDataLoading = false;
      },
      (error) => {
        console.log(error);
        this.sectorsDataLoading = false;
      }
    );
  }

  onChangeRegions(regions): void {
    this.filter.regionsSelected = regions.map((region) => region.name);
    this.filter.branchesSelected = null;
    this.filter.sectorNumbersSelected = null;
    this.filter.districtsSelected = null;

    this.getBranches(this.filter.regionsSelected);
    this.getSectorsNames();
  }

  onChangeBranches(branches): void {
    this.filter.branchesSelected = branches.map((branch) => branch.mb_id);
    this.filter.sectorNumbersSelected = null;
    this.filter.districtsSelected = null;

    this.getSectorsNames();
    this.getDistricts();
  }

  onChangeSectorsNumbers(sectorsNumbers): void {
    this.filter.sectorNumbersSelected = sectorsNumbers.map((s) => s.sector_id);
    this.filter.districtsSelected = null;

    this.getDistricts();
  }

  onChangeDistricts(districts): void {
    this.filter.districtsSelected = districts.map((district) => district.d_id);
  }

  onApplyFilter(): void {
    this.paginationBlock.filterDataOffset = 0;
    this.sectors = null;
    this.getSectors();
  }

  onResetFilter(): void {
    this.filter.data.districts = null;
    this.filter.regionsSelected = null;
    this.filter.branchesSelected = null;
    this.filter.districtsSelected = null;
    this.filter.sectorNumbersSelected = null;
    this.paginationBlock.filterDataOffset = 0;
    this.sectors = null;

    this.getMonitoringDataUnion();
  }

  onChangeLimitCountShowPlots(limit: number): void {
    this.paginationBlock.selectedLimit = limit;
    this.paginationBlock.countShowPlots = limit;
  }

  toggleWithActionsContext(popover: NgbPopover, sector: any): void {
    if (popover.isOpen()) {
      popover.close();
      this.sectorOpenedActions = null;
    } else {
      this.sectorOpenedActions = sector;
      popover.open();
    }
  }
}
